import { render, staticRenderFns } from "./CollectDetailLink.vue?vue&type=template&id=a9ad9c0a&scoped=true"
import script from "./CollectDetailLink.vue?vue&type=script&lang=js"
export * from "./CollectDetailLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ad9c0a",
  null
  
)

export default component.exports